import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function FriendlyMessage({ buttonText, children, title, url }) {
  return (
    <div className="friendly-message friendly-message--has-avatar">
      <h2>
        {title}
      </h2>

      {children}

      <div>
        <Link className="btn btn--primary" to={url}>
          {buttonText}
        </Link>
      </div>
    </div>
  );
});
